<template>
  <section class="my-32">
    <div class="container">
      <h1
        class="text-[#000] font-Approach font-semibold text-center uppercase text-[60px]"
      >
        Pick Your Perfect Plan
      </h1>
      <div class="flex flex-col gap-3 items-center mb-20">
        <div
          class="tab-switch select-plan flex px-3 items-center justify-center gap-5 m-auto mt-10 py-8"
          :class="direction"
        >
          <!--  -->
          <div
            class="tab text-[#000] rounded-[99px] transition ease-linear text-[#000] text-[18px] font-semibold px-[24px] py-[14px]"
            v-for="(tab, index) in switcherListed"
            :key="index"
            @click="setActiveTab(index)"
            :class="{ active: tab.active }"
            :tab-direction="tab.direction"
          >
            {{ tab.text }}
          </div>
          <!--  -->
        </div>
        <span class="text-[#000] font-medium">Save up to 25%</span>
      </div>
    </div>
  </section>
</template>
<script>
import { ref, computed } from "vue";
export default {
  name: "subscribe-component",
  setup() {
    const switcherListed = ref([
      { text: "Monthly", direction: "left", active: true },
      { text: "Yearly", direction: "right", active: false },
    ]);

    const setActiveTab = (index) => {
      const tab = switcherListed.value[index];

      if (tab.active) return;

      switcherListed.value.forEach((t) => {
        t.active = false;
      });

      tab.active = true;
      direction.value = tab.direction;
    };
    const direction = computed(() => {
      return switcherListed.value.find((t) => t.active).direction;
    });

    return {
      switcherListed,
      setActiveTab,
      direction,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "~/public/styles/subscribe/index.scss";
</style>
